var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9193 11.2753C12.9113 10.4233 12.3333 9.178 12.3333 7.85867V6C12.3333 3.654 10.5907 1.712 8.33333 1.38667V0.666667C8.33333 0.298 8.03467 0 7.66667 0C7.29867 0 7 0.298 7 0.666667V1.38667C4.742 1.712 3 3.654 3 6V7.85867C3 9.178 2.422 10.4233 1.408 11.2807C1.14867 11.5027 1 11.8253 1 12.1667C1 12.81 1.52333 13.3333 2.16667 13.3333H13.1667C13.81 13.3333 14.3333 12.81 14.3333 12.1667C14.3333 11.8253 14.1847 11.5027 13.9193 11.2753Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66674 16C8.87407 16 9.88407 15.1393 10.1161 14H5.21741C5.44941 15.1393 6.45941 16 7.66674 16Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.5b2fb1a30a3cfdd8aac31b6687281f08.svg";
export { ForwardRef as ReactComponent };